import React, { useEffect, useState } from 'react'
import { MODE } from '../constant'
import { Col, Form, Row, Typography, message } from 'antd'
import BtnEditUC from '../../../components/Form/BtnEditUC'
import BtnDeleteUC from '../../../components/Form/BtnDeleteUC'
import ButtonUC from '../../../components/buttonUC'
import HeaderBarAdd from '../headerBarAdd'
import InputUC from '../../../components/Form/InputUC'
import SelectUC from '../../../components/Form/SelectUC'
import useDropdown from '../context/useDropdown'

const Contact = ({ props }) => {
    const {
        form,
        rcAppProfileReference,
        setRcAppProfileReference,
        rcDeletedData,
        setRcDeletedData } = props

    const { Text } = Typography
    const [mode, setMode] = useState(MODE.VIEW) //view, edit
    const [isReq, setReq] = useState(false)
    const { ddlRelation, getDDLLabel } = useDropdown()
    const relationWatch = Form.useWatch('ref_con_relation', form);
    const isMobile = window.innerWidth <= 992

    useEffect(() => {
        setReq(mode === MODE.EDIT)
    }, [mode])

    const handleAdd = () => {
        console.log('handleAdd')
        // new
        let newRow = {
            sort: 1,
            firstName: null,
            lastName: null,
            jobTitle: null,
            employer: null,
            phone: null,
            relation: null,
            type: 'contact',
            otherRelation: null
        }

        if (rcAppProfileReference && rcAppProfileReference.length > 0) {
            const max = Math.max(...rcAppProfileReference.map(o => o.sort))
            newRow = {
                ...newRow,
                sort: max + 1,
            }
        }

        setForm(newRow)
        setMode(MODE.EDIT)
    }

    const setForm = (record) => {
        form.setFieldsValue({
            ref_con_sort: record.sort,
            ref_con_firstName: record.firstName,
            ref_con_lastName: record.lastName,
            ref_con_jobTitle: record.jobTitle,
            ref_con_employer: record.employer,
            ref_con_phone: record.phone,
            ref_con_relation: record.relation,
            ref_con_type: record.type,
            ref_con_other_relation: record.otherRelation
        })
    }

    const handleEdit = (record) => {
        console.log('handleEdit', record)
        if (record) {
            setForm(record)
            setMode(MODE.EDIT)
        }
    }

    const handleDelete = (record) => {
        if (record.id) {
            // เก็บ Record ที่ลบ
            setRcDeletedData([...rcDeletedData, { id: record.id, tableName: 'appProfileReference' }])
        }
        setRcAppProfileReference(rcAppProfileReference.filter(r => r.sort !== record.sort))
    }

    const handleCancel = () => {
        setMode(MODE.VIEW)
    }

    const handleSubmit = () => {
        console.log('handleSubmit')
        const dataPreSubmit = {
            sort: form.getFieldValue('ref_con_sort'),
            firstName: form.getFieldValue('ref_con_firstName'),
            lastName: form.getFieldValue('ref_con_lastName'),
            jobTitle: form.getFieldValue('ref_con_jobTitle'),
            employer: form.getFieldValue('ref_con_employer'),
            phone: form.getFieldValue('ref_con_phone'),
            relation: form.getFieldValue('ref_con_relation'),
            otherRelation: form.getFieldValue('ref_con_other_relation'),
            type: form.getFieldValue('ref_con_type'),
        }

        const dataColValidate = [
            { caption: "กรุณากรอกชื่อ", columnName: "ref_con_firstName" },
            { caption: "กรุณากรอกนามสกุล", columnName: "ref_con_lastName" },
            { caption: "กรุณากรอกเกี่ยวข้องเป็น", columnName: "ref_con_relation" },
            { caption: "กรุณากรอกเบอร์โทรศัพท์มือถือ", columnName: "ref_con_phone" },
            { caption: "กรุณากรอกอื่น ๆ (โปรดระบุ)", columnName: "ref_con_other_relation" },
        ]

        let isValidate = false
        dataColValidate.forEach(el => {
            const _isValidate = checvalidateDraft(el)
            isValidate = isValidate ? isValidate : (_isValidate ?? false)
        })

        if (isValidate) {
            message.warning('กรุณากรอกข้อมูลบุคคลที่สามารถติดต่อได้');
            return false
        } else {
            const row = rcAppProfileReference.filter(item => item.sort === dataPreSubmit.sort)
            if (row && row.length > 0) {
                setRcAppProfileReference(rcAppProfileReference.map((obj) => obj.sort === dataPreSubmit.sort ? dataPreSubmit : obj))
            } else {
                setRcAppProfileReference([...rcAppProfileReference, dataPreSubmit])
            }

            setMode(MODE.VIEW)
        }
    }

    const checvalidateDraft = (e) => {
        const _data = form.getFieldValue([e.columnName])
        if (!_data || _data === '') {
            if ((e.columnName === 'ref_con_other_relation' && relationWatch === 'other') || e.columnName !== 'ref_con_other_relation') {
                form.setFields([
                    {
                        name: [e.columnName],
                        errors: [e.caption],
                    },
                ]);
                return true
            }
        }
        return false
    }

    const handleChange = (e) => {
        let inputValue = e.target.value;
        const reg = /^-?\d*(\.\d*)?$/;
        if (!(reg.test(inputValue) || inputValue === '' || inputValue === '-')) {
            inputValue = inputValue.length > 0 ? (inputValue.substring(0, inputValue.length - 1)) : ''
        }
        form.setFieldsValue({ ref_con_phone: inputValue });
    };

    const handleChangeRelation = () => {
        form.setFieldsValue({ ref_con_other_relation: null })
    }

    const FormView = ({ data }) => {
        const _relation = data.relation === 'other' ? `${data.otherRelation} (อื่น ๆ)` : getDDLLabel(ddlRelation, data.relation)
        return (
            <>
                <Row className="py-2 p-3 justify-between">
                    <Col xs={24} md={8} className='px-2 flex items-center'>
                        <Text className='text-name color-secondary1'>{`${data.firstName} ${data.lastName}`}</Text>
                    </Col>
                    <Col xs={12} md={6} className='px-2 flex items-center'>
                        <Text className='text-relation mr-1'>เกี่ยวข้องเป็น :</Text>
                        <Text
                            className='text-relation color-gray6 line-clamp-1'
                            style={{ maxWidth: '100px' }}
                            title={_relation}
                        >{_relation}</Text>
                    </Col>
                    <Col xs={12} md={6} className='px-2 flex items-center'>
                        <Text className='text-phone mr-1'>เบอร์โทรศัพท์ :</Text>
                        <Text className='text-phone color-gray6'>{data.phone}</Text>
                    </Col>
                    <Col xs={24} md={4} className='px-2'>
                        <div className="flex justify-end">
                            <BtnEditUC disabled={data.isCanNotEdit === true} handleEdit={() => handleEdit(data)} />
                            <BtnDeleteUC disabled={data.isCanNotDelete === true} handleDelete={() => handleDelete(data)} />
                        </div>
                    </Col>
                </Row>
            </>
        )
    }


    const FormEdit = () => {
        return (
            <>
                <Row className="py-2">
                    <Col xs={24} md={8} className='px-2'>
                        <InputUC required={isReq} label='ชื่อ' name={'ref_con_firstName'} maxLength={100} />
                    </Col>
                    <Col xs={24} md={8} className='px-2'>
                        <InputUC required={isReq} label='นามสกุล' name={'ref_con_lastName'} maxLength={100} />
                    </Col>
                    <Col xs={24} md={8} className='px-2'>
                        <InputUC required={isReq} label='เบอร์โทรศัพท์มือถือ' name={'ref_con_phone'} maxLength={10} onChange={handleChange} />
                    </Col>
                </Row>
                <Row className="py-2">
                    {/* <InputUC required={isReq} label='เกี่ยวข้องเป็น' name={'ref_con_relation'} maxLength={50} /> */}
                    <Col xs={24} md={8} className='px-2'>
                        <SelectUC
                            required={true}
                            label='เกี่ยวข้องเป็น'
                            name={'ref_con_relation'}
                            optionValues={ddlRelation}
                            onChange={handleChangeRelation}
                            showSearch={true} />
                    </Col>
                    <Col xs={24} md={8} className={`px-2 ${isMobile ? ' py-2' : ''}`}>
                        <InputUC
                            required={relationWatch === 'other'}
                            disabled={relationWatch !== 'other'}
                            showPlaceholder={relationWatch === 'other'}
                            label='กรณีเลือกอื่น ๆ (โปรดระบุ)'
                            name={'ref_con_other_relation'}
                            maxLength={100} />
                    </Col>
                </Row>
                <Row className="py-2">
                    <Col span={24} className='px-2 flex justify-end'>
                        <ButtonUC className='btn-clear mr-3' onClick={() => handleCancel()}>ยกเลิก</ButtonUC>
                        <ButtonUC className='btn-custom ml-3' onClick={() => handleSubmit()}>บันทึก</ButtonUC>
                    </Col>
                </Row>
            </>
        )
    }

    return (
        <div className='div-contact w-full'>
            <HeaderBarAdd title={'บุคคลที่สามารถติดต่อได้'} handleAdd={handleAdd} disabled={mode === 'edit'} />
            {mode === 'view' && rcAppProfileReference && rcAppProfileReference.filter(r => r.type === 'contact').length > 0 ?
                <>
                    {rcAppProfileReference.filter(r => r.type === 'contact').map((item, index) => {
                        return (
                            <FormView key={index} data={item} />
                        )
                    })}
                </>
                : <>{mode === 'edit' && <FormEdit />}</>}
        </div>
    )
}

export default Contact